import script from "./CustomTextarea.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomTextarea.vue?vue&type=script&lang=ts&setup=true"

import "./CustomTextarea.vue?vue&type=style&index=0&id=7a7222ac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a7222ac"]])

export default __exports__